export type PostTokenData = {
    token: string;
    provider: string;
};

export type OnPostToken = (data: PostTokenData) => void;

const POST_TOKEN__ID = 'POST_TOKEN__ID';

export const listenPostToken = (onPostToken: OnPostToken) => {
    const removePostTokenListener = () => {
        window.removeEventListener('message', handlePostToken, false);
    };
    const handlePostToken = ({ data: { id, message } }: MessageEvent) => {
        if (id !== POST_TOKEN__ID) return;

        onPostToken(message);
        removePostTokenListener();
    };
    window.addEventListener('message', handlePostToken, false);
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/helpers/tokenMessage.ts